module.exports = __webpack_public_path__ + "img/cbt_btn_open.232c340f.png";